import { z } from 'zod'
import { Permission } from '../types/roles.types'

export const roleSchema = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  name: z.string(),
  fullAccess: z.boolean(),
  permissions: z.array(z.enum(Permission)),
  color: z.string(),
  createdAt: z.iso.datetime().optional(),
  updatedAt: z.iso.datetime().optional()
})
